import { get, last, castArray } from 'lodash';

export default (notes = [], action = '') => {
  const filteredData = notes.filter(note => {
    const { content: { action: noteAction = '' } = {} } = note;
    return castArray(action).includes(noteAction);
  });
  return get(last(filteredData), 'content', {});
};
